import { jsxs as e, jsx as l } from "react/jsx-runtime";
const o = (c) => /* @__PURE__ */ e(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25",
    ...c,
    children: [
      /* @__PURE__ */ l("g", { clipPath: "url(#weebly-colored_svg__a)", children: /* @__PURE__ */ l(
        "path",
        {
          fill: "#3192E7",
          d: "M19.904 3.852c-1.872 0-3.433 1.245-3.911 3.108-.863-2.8-3.071-3.106-3.993-3.106-.92 0-3.128.306-3.992 3.105-.48-1.861-2.04-3.105-3.912-3.105C1.8 3.854 0 5.496 0 7.592c0 .927.229 1.667.506 2.47l3.119 8.82c1.044 2.924 3.171 3.361 4.346 3.361 1.844 0 3.28-.944 4.03-2.617.749 1.68 2.185 2.63 4.028 2.63 1.173 0 3.299-.438 4.348-3.374l3.136-8.85.025-.072q.054-.17.106-.321c.167-.494.356-1.054.356-1.74 0-2.345-1.723-4.047-4.096-4.047m1.478 5.426-3.136 8.85c-.382 1.07-1.02 1.867-2.217 1.867-1.123 0-1.786-.626-2.117-1.697l-1.887-5.89h-.051l-1.886 5.89c-.332 1.072-.995 1.685-2.117 1.685-1.198 0-1.835-.79-2.218-1.862l-3.11-8.796c-.255-.74-.382-1.197-.382-1.733 0-.816.765-1.477 1.835-1.477.893 0 1.53.588 1.734 1.455l2.116 7.016h.05l2.143-6.862c.28-.994.79-1.61 1.861-1.61s1.58.615 1.861 1.61l2.142 6.862h.05L18.17 7.57c.204-.867.841-1.458 1.734-1.458 1.07 0 1.835.664 1.835 1.786 0 .408-.179.818-.357 1.38"
        }
      ) }),
      /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "weebly-colored_svg__a", children: /* @__PURE__ */ l("path", { fill: "#fff", d: "M0 3.85h24v18.47H0z" }) }) })
    ]
  }
);
export {
  o as default
};
